import React from 'react';
import { Navigate } from 'react-router-dom';
import _ from 'lodash';
import { Grid, GridColumn, GridToolbar } from '@progress/kendo-react-grid';
import Navigation from 'Components/Navigation';
import LoadingPageContent from 'Components/LoadingPageContent';
import BookingReferenceSearchPanel from 'Components/BookingReferenceSearchPanel';
import { userService, bookingReferenceService } from 'Services';
import { withRouter } from 'Components/withRouter';
import { withAuthenticatedUser } from 'Components/withAuthenticatedUser';
import styles from './BookingReferenceQueryPage.module.css';

class DeleteCell extends React.Component {
    render() {
        return (
            <td colSpan={this.colSpan}>
                <button className="btn btn-dl-green pull-right" onClick={event => {this.props.DeleteBookingReference(event,this.props.dataItem)}}>DELETE</button>
            </td>
        );
    }
  }

class EditCell extends React.Component {
    render() {
        return (
            <td colSpan={this.colSpan}>
                <button className="btn btn-dl-green pull-right" onClick={event => {this.props.EditBookingReference(event,this.props.dataItem)}}>EDIT</button>
            </td>
        );
    }
}

class BookingReferenceQueryPage extends React.Component {

    constructor(props) {
        super(props);
        
        this.state = {
            queryResult: {
                data: [],
                total: 0
            }
        }

        this.handleQuery = this.handleQuery.bind(this);
    }

    componentDidMount() {

        const formData = new FormData(document.getElementById('bookingReferenceQueryForm'));
        this.handleQuery(formData);

    }

    handleQuery(formData) {

        var data = {};
        
        formData.forEach((value, key) => {
            data[key] = value;
        });

        bookingReferenceService.getBookingReferences(formData)
            .then(response => {
                if (response.status === 200) {

                    var sortedData = _.sortBy(response.data, [br => br.reference.toLowerCase()]);

                    this.setState({
                        queryResult: {
                            data: sortedData.map(br => {
                                return {
                                    id: br.id,
                                    reference: br.reference,
                                    markup: br.markup / 100
                                };
                            }),
                            total: response.total
                        }
                    });
                }
            })
            .catch(error => console.log(error));

    }

    AddBookingReference = () => {

        const formData = new FormData(document.getElementById('bookingReferenceQueryForm'));
        var account = formData.get("account");
        this.props.router.navigate(
            '/booking_reference?id=-1',
            {
                selectedAccount: account
            });
    }

    EditBookingReference = (event,record) => {
        event.preventDefault();
        this.props.router.navigate('/booking_reference?id=' + record.id);
        // window.alert(user_id);
    }

    DeleteBookingReference = (event, record) => {
        event.preventDefault();

        var br_id = record.id;

        bookingReferenceService.deleteBookingReference(br_id)
            .then(response => {
                if (response.status === 200) {
                    alert('Booking reference deleted.');
                    const formData = new FormData(document.getElementById('bookingReferenceQueryForm'));
                    this.handleQuery(formData);
                }
            });
    }

    EditCell = (props) => <EditCell {...props} EditBookingReference={this.EditBookingReference} />
    DeleteCell = (props) => <DeleteCell {...props} DeleteBookingReference={this.DeleteBookingReference} />

    render() {

        var privileges = null;
        var defaultAccount = null;
        var accountOptions = null;

        if (this.props.authenticatedUser) {
            privileges = this.props.authenticatedUser.privileges;
            defaultAccount = this.props.authenticatedUser.default_account;
            accountOptions = this.props.authenticatedUser.accounts;
        }

        var canManageReferences = privileges &&
            _.some(privileges, ['description', 'Manage References']);
        
        if (!canManageReferences)
            return <Navigate to="/Welcome" />

        return (
            <div id="bookingReferences">
                <Navigation active="admin" authenticatedUser={this.props.authenticatedUser} />
                <div className="container-fluid padding-lr55 bg-form">
                    <div className="row h3">
                        <div className="col-xs-12">Booking References</div>
                    </div>
                    <div className="padding-tb10" />
                    <div className="row">
                        <div className="col-sm-12">
                            <BookingReferenceSearchPanel defaultAccount={defaultAccount} accountOptions={accountOptions} onFormSubmit={this.handleQuery} />
                        </div>
                    </div>
                </div>
                <div className="container-fluid padding-lr55">
                    <div className="padding-tb10" />
                    <Grid
                        styleName="styles.grid"
                        data={this.state.queryResult}
                        >
                        <GridToolbar>
                            <button type="button" className="btn btn-default btn-dl-green" onClick={this.AddBookingReference}>NEW REFERENCE</button>
                        </GridToolbar>
                        <GridColumn title="Reference" field="reference" width="200px"/>
                        <GridColumn title="Markup" field ="markup" format="{0:p3}" width="120px" />
                        <GridColumn field="id" title=" " cell={this.EditCell} width="80px"/>
                        <GridColumn field="id" title= " " cell={this.DeleteCell} width="120px" />
                    </Grid>
                    <div className="padding-tb10" />
                </div>
            </div>
            );
    }
}

const authenticatedBookingReferenceQuerypage = withAuthenticatedUser(withRouter(BookingReferenceQueryPage));

export { authenticatedBookingReferenceQuerypage as BookingReferenceQueryPage };